import {NormalizerI} from "./normalizer.i";

export class PercentageNormalizer implements NormalizerI {

    normalize(model: string): string {
        const percentage = parseInt(model);
        if (percentage >= 1 && percentage <= 100) {
            return percentage.toString();
        }
        if (percentage < 1) {
            return '';
        }
        if (percentage > 100) {
            if (model.startsWith('100')) {
                return model.substring(0, 3);
            }
            return model.substring(0, 2);
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/normalizers/percentage.normalizer.ts